import { Reveal, Eyebrow } from "../components/Reveal";

const SECTIONS = [
  {
    title: "What we collect",
    body: "If you send an enquiry through this website, we collect the details you enter: your name, organisation, email address, site location, the type of project and your message. We do not run analytics, advertising trackers or marketing cookies on this site.",
  },
  {
    title: "How it's used",
    body: "Your details are used only to respond to your enquiry and, if the project goes ahead, to plan and deliver the work. We do not sell your details, share them with marketers, or add you to a mailing list.",
  },
  {
    title: "How it's delivered and stored",
    body: "The enquiry form is delivered by Web3Forms, a third-party form service, which forwards your message to us by email. Their handling of the message in transit is covered by their own privacy terms. Enquiry emails are kept only as long as needed to handle your enquiry and any resulting work.",
  },
  {
    title: "Your rights",
    body: "You can ask at any time to see the details we hold about you, to have them corrected, or to have them deleted. Send a message through the contact form and we'll take care of it promptly.",
  },
  {
    title: "Changes",
    body: "If this policy changes, the updated version will be published on this page.",
  },
];

export default function Privacy() {
  return (
    <section data-testid="privacy-page" className="mx-auto max-w-3xl px-5 pb-24 pt-40 md:px-8 md:pt-52">
      <Reveal><Eyebrow>Privacy</Eyebrow></Reveal>
      <Reveal delay={0.1}>
        <h1 className="mt-5 font-serif text-4xl leading-tight tracking-tight text-forest sm:text-5xl">
          Privacy policy
        </h1>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-6 text-base leading-relaxed text-charcoal/85">
          Cotswold Drone Mapping respects your privacy. This page explains, in plain English, what happens to
          any details you share through this website.
        </p>
      </Reveal>
      <div className="mt-12 space-y-10">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={0.05 * i} className="border-b border-forest/15 pb-8">
            <h2 className="font-serif text-xl text-forest md:text-2xl">{s.title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-charcoal/80 md:text-base">{s.body}</p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <p className="mt-8 text-xs italic leading-relaxed text-charcoal/60">
          Last reviewed: July 2026. This policy should be reviewed alongside any formal legal advice before
          trading.
        </p>
      </Reveal>
    </section>
  );
}
